import clsx from 'clsx'
import Link from 'next/link'

import styles from './noattempts-widget.module.scss'
import common from '../../registration-code.module.scss'

const NoAttemptsWidget = () => {
  return (
    <div className={common.wrapperCommon}>
      <div className={clsx(common.title, styles.title)}>Вы исчерпали количество попыток входа</div>

      <div className={styles.emailInfo}>
        Напишите на почту{' '}
        <Link href="mailto:info@medpoint.pro">
          <span className={common.link}>info@medpoint.pro</span>
        </Link>
        <br /> для восстановления аккаунта
      </div>
    </div>
  )
}

export default NoAttemptsWidget
